import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import { UserDataContext } from "../Contexts/UserDataContext";
import WeekRoute from "./WeekRoute";
import DefaultRoute from "./DefaultRoute";

const TruckRoute = () => {
  const { userData, setUserData } = useContext(UserDataContext);

  return (
    <>
      {userData.invoiceStatuses ? (
        <Switch>
          {userData.trucks.map((truckObj) => (
            <Route
              key={truckObj.truckId}
              path={`/${userData.userName}/trucks/${truckObj.truckId}`}
              // component={() => <TruckViewPage truckId={truckObj.truckId} />}
              component={() => <WeekRoute truckId={truckObj.truckId} />}
            />
          ))}
          <DefaultRoute />
        </Switch>
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};

export default TruckRoute;
